// W2: PostHog SDK debug-mode gating.
// Per rule: stay-in-scope (ai.knowledge/global) — engineer scope freeze:
// errors+warnings only, env-gated debug. Production builds MUST NEVER set
// debug:true even when the diag env is set (defense-in-depth).
// Per rule: code-comments-required (ai.knowledge/global) — explain WHY, not WHAT.

// Vite injects PROD/DEV at build time. Custom IRIS_* env vars are surfaced
// via define()/loadEnv in vite.config; access them as opaque strings.
type ViteEnv = {
  readonly PROD?: boolean;
  readonly DEV?: boolean;
  readonly IRIS_DIAG_POSTHOG?: string;
  readonly [key: string]: unknown;
};

function readEnv(): ViteEnv {
  // Cast through unknown so the function compiles in non-Vite contexts
  // (jest sometimes runs without Vite's import.meta polyfill).
  const meta = (typeof import.meta !== 'undefined' ? import.meta : {}) as { env?: ViteEnv };
  return meta.env ?? {};
}

// Returns true ONLY when IRIS_DIAG_POSTHOG=1 OR the build is a Vite dev build.
// Production wins unconditionally — if PROD is true, debug is always off.
export function shouldEnablePostHogDebug(): boolean {
  const env = readEnv();

  // Defense-in-depth: production short-circuits before any opt-in is checked.
  if (env.PROD === true) {
    return false;
  }

  if (env.IRIS_DIAG_POSTHOG === '1') {
    return true;
  }

  return env.DEV === true;
}
